import React from 'react';

const CHART_HEIGHT = 104;

function MiniBarChart({ bars = [], color = 'var(--sl-fg-brand)', valueFormatter = (value) => `${value}` }) {
  const max = Math.max(0, ...bars.map((bar) => bar.value || 0));
  if (max <= 0) return null;

  return (
    <div className="cdp-bar-chart" style={{ height: CHART_HEIGHT }}>
      {bars.map((bar) => (
        <div key={bar.label} className="cdp-bar" tabIndex={0}>
          <div className="cdp-bar-tooltip" role="tooltip">
            {bar.label}: {valueFormatter(bar.value || 0)}
          </div>
          <div className="cdp-bar-track" style={{ height: CHART_HEIGHT - 20 }}>
            <div
              className="cdp-bar-fill"
              style={{
                height: `${Math.max(2, ((bar.value || 0) / max) * 100)}%`,
                backgroundColor: color,
              }}
            />
          </div>
          <div className="cdp-bar-label">{bar.label}</div>
        </div>
      ))}
    </div>
  );
}

export default MiniBarChart;
